import {defineStore} from 'pinia';
import {ContentClient} from "@/clients/ContentClient";

export const usePathsStore = defineStore('path', {
    state: () => ({
        content: null,
        path: null
    }),
    getters: {
        pathContent(state) {
            return state.content;
        },
        pathItems(state) {
            return state.path;
        },
    },
    actions: {
        async getPath(id) {
            let response = await ContentClient.getPath(id);
            this.content = response.data.content;
            this.path = response.data.path;
        },
    },
})
